
export const arrayChoicesToObject = (choices)=>{
    let result = {}
    choices.forEach(([key, value])=>{
        result[key] = value;
    })
    return result
}